import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { pillars, volumes, volumeIncludes } from '../data/volumes';
export function Volumes() {
  return <section aria-label="System contents" className="bg-transparent" data-id="element-273" data-mp="184f1q1waxg7h">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: '19px',
      paddingBottom: "21px"
    }} data-id="element-274" data-mp="18228gsl3fjf4">
        <div className="text-center" data-id="element-275" data-mp="1zv1m989uh1lw">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-blush" data-id="element-276" data-mp="1zw4bzcvfky08">
            THE 100 LEGAL PRECEDENTS AI™: THE SYSTEM
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-277" data-mp="24rs33xth418d">
            📚 The 6-Volume Strategic Vault
          </h2>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-278" data-mp="1vseqiwa1ywjf">
            {pillars.map(p => <span key={p} className="rounded-full border border-grape/25 bg-lilac-soft px-3 py-1 text-xs font-bold uppercase tracking-wide text-grape-deep" data-id="element-279" data-mp="feoi5dbwhm3z">
                {p}
              </span>)}
          </div>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-280" data-mp="3o8yaz2zluppd">
          {volumes.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 3 * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border border-grape/15 bg-white p-5" style={{
          paddingTop: "10px",
          paddingBottom: "8px"
        }} data-id="element-281" data-mp="3jadg7j34gy8b" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-282" data-mp="60h5ugog6gko">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-plum font-display text-lg font-black text-white" data-id="element-283" data-mp="kqensevsaa1f">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-plum" data-id="element-284" data-mp="tsnwr0belvcp">
                  <span aria-hidden="true" data-id="element-285" data-mp="prkj8kgtwben">{t.emoji} </span>
                  {t.title}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-plum/65" data-id="element-286" data-mp="wvai0lhzp7yx">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-grape/25 bg-white p-6" data-id="element-287" data-mp="11qhhfh487qi1">
          <p className="text-center font-display text-lg font-black text-grape" data-id="element-288" data-mp="16qm1fh4cf3d0">
            ✅ Every Volume includes:
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-289" data-mp="1fkh7crdagxtp">
            {volumeIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-plum/75" data-id="element-290" data-mp="1fmlc1bj0i0v1">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-291" data-mp="1klen6xattfs1" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}